//user
export const userTypes = {
  SET_USER: "SET_USER",
  REMOVE_USER: "REMOVE_USER",
  SET_SELECTED_BRANCH: "SET_SELECTED_BRANCH",
  SET_USER_AUTHS: "SET_USER_AUTHS",
};

export const menuTypes = {
  SET_MENU: "SET_MENU",
  REMOVE_MENU: "REMOVE_MENU",
};


export const authTypes = {
  SUCCESS_LOGIN: "SUCCESS_LOGIN",
  SUCCESS_SIGNUP: "SUCCESS_SIGNUP",
};

export const SET_LOCALE = "SET_LOCALE";